import React from 'react';
import { Button, Card, Dialog, IconButton, InputLabel, Grid, TextField, Typography, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import axios from 'axios';
import swal from '@sweetalert/with-react';

import { EVENT_ID, focusElementRef, WEB_API, EVENT_IMG } from '../constatns';

const styles = (theme) => ({
  box: {
    // alignItems: 'center',
    // display: 'flex',
    // flexDirection: 'column',
    // width: '45%',
    // padding: '40px 60px 30px',
    borderRadius: '5px',
    cursor: 'pointer',
    justifyContent: 'center',

    '&:first-child': {
      backgroundColor: 'rgba(228,243,178,0.5)',
      '&:hover': {
        backgroundColor: '#e4f3b2',
        '& p': {
          color: '#aacb3c',
        },
      },
    },
    '&:last-child': {
      backgroundColor: 'rgba(120,193,228,0.5)',
      '&:hover': {
        backgroundColor: '#78c1e4',
        '& p': {
          color: '#164273',
        },
      },
    },
    '& p': {
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '1.6em',
      paddingTop: '20px',
    },
  },
  cardBox: {
    padding: theme.spacing(5),
  },
  inputLabel: {
    color: '#000',
    marginBottom: '5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  formInput: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0',
    },
  },
  loginInfo: {
    textAlign: 'center',
    color: '#999',
    fontSize: '1em',
    lineHeight: 1.7,
    marginTop: 10,
    '& span': {
      color: 'red',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
      '& span': {
        fontSize: '8px',
      },
    },
  },
  submit: {
    fontSize: '1.1em',
    marginTop: theme.spacing(2),
    padding: theme.spacing(2, 0),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 0, 1),
    },
  },
});

class FindID extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',

      firstName: '',
      lastName: '',
      language: '',
      license: '',

      matches: window.matchMedia('(max-width:600px)').matches,
    };

    this.handleChange = this.handleChange.bind(this);

    this.refName = React.createRef();
    this.refLicense = React.createRef();
    this.refFirst = React.createRef();
    this.refLast = React.createRef();
  }

  componentDidMount() {}

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  selectLanguage(language) {
    this.setState({ language }, () => {
      this.props.handleState('isFindSelectOpen', false);
      this.props.handleState('isFindIdOpen', true);
    });
  }

  closeDialog() {
    this.props.handleState('isFindSelectOpen', false);
    this.props.handleState('isFindIdOpen', false);
  }

  submit = () => {
    if (this.state.language === 'korean') {
      if (!this.state.name) focusElementRef('이름을 입력해주세요.', this.refName);
      else if (!this.state.license) focusElementRef('의사면허번호를 입력해주세요.', this.refLicense);
      else {
        axios.get(`${WEB_API}/user/checkUser?eventId=${EVENT_ID}&username=${this.state.name}&license=${this.state.license}`).then((res) => {
          if (res.status === 200 && res.data.length > 0 && res.data[0].isDel !== 1) {
            swal('검색완료', `문의주신 ID(E-mail)은 ${res.data[0].email} 입니다.`, 'success');
          } else {
            axios
              .get(`${WEB_API}/user/checkUser?eventId=${EVENT_ID}&username=${this.state.name}&license=(추천)${this.state.license}`)
              .then((res) => {
                // console.log(res);
                if (res.status === 200 && res.data.length > 0) {
                  swal('검색완료', `문의주신 ID(E-mail)은 ${res.data[0].email} 입니다.`, 'success');
                } else {
                  swal('검색불가', '이름과 의사면허번호를 확인해주세요.', 'error');
                }
              });
          }
        });
      }
    } else {
      if (!this.state.firstName) focusElementRef('Please input your first name.', this.refFirst);
      else if (!this.state.lastName) focusElementRef('Please input you last name.', this.refLast);
      else {
        axios
          .get(`${WEB_API}/user/checkUser?eventId=${EVENT_ID}&firstName=${this.state.firstName}&lastName=${this.state.lastName}`)
          .then((res) => {
            if (res.status === 200 && res.data.length > 0 && res.data[0].isDel !== 1) {
              swal('Search completed', `Your ID(E-mail) is ${res.data[0].email}`, 'success');
            } else {
              swal('Unseacrhable ID', 'Please check your name.', 'error');
            }
          });
      }
    }
  };

  renderKr() {
    const { classes } = this.props;
    return (
      <Grid container spacing={2}>
        <Grid item container justifyContent="space-between" alignItems="center">
          <InputLabel htmlFor="email" className={classes.inputLabel}>
            Name(국문)
          </InputLabel>
          <TextField
            variant="outlined"
            size="small"
            required
            id="name"
            type="text"
            name="name"
            onChange={(e) => {
              this.handleChange('name', e);
            }}
            value={this.state.name}
            className={classes.formInput}
            inputRef={this.refName}
            style={{ width: '60%' }}
          />
        </Grid>
        <Grid item container justifyContent="space-between" alignItems="center">
          <InputLabel htmlFor="email" className={classes.inputLabel}>
            CME Credit(의사면허번호)
          </InputLabel>
          <TextField
            variant="outlined"
            size="small"
            required
            id="license"
            type="number"
            name="license"
            onChange={(e) => {
              this.handleChange('license', e);
            }}
            value={this.state.license}
            className={classes.formInput}
            inputRef={this.refLicense}
            style={{ width: '60%' }}
          />
        </Grid>
      </Grid>
    );
  }

  renderInternational() {
    const { classes } = this.props;
    return (
      <Grid container>
        <Grid item container justifyContent="space-between" alignItems="center">
          <InputLabel htmlFor="email" className={classes.inputLabel}>
            Name(Full)
          </InputLabel>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '1em' }}>
            <TextField
              variant="outlined"
              size="small"
              required
              id="first-name"
              type="text"
              name="firstName"
              onChange={(e) => {
                this.handleChange('firstName', e);
              }}
              placeholder={'First Name'}
              value={this.state.firstName}
              className={classes.formInput}
              inputRef={this.refFirst}
              style={{ width: '47.5%' }}
            />
            <TextField
              variant="outlined"
              size="small"
              required
              id="last-name"
              type="text"
              name="lastName"
              onChange={(e) => {
                this.handleChange('lastName', e);
              }}
              placeholder={'Last Name'}
              value={this.state.lastName}
              className={classes.formInput}
              inputRef={this.refLast}
              style={{ width: '47.5%' }}
            />
          </div>
        </Grid>
      </Grid>
    );
  }

  render() {
    const { classes, theme } = this.props;

    return (
      <>
        {/* 국적 선택 다이얼로그 */}
        <Dialog
          open={this.props.selectopen}
          //  close={this.props.selectclose}
          maxWidth={'sm'}
        >
          <IconButton style={{ position: 'absolute', top: '0.5em', right: '0.5em' }} onClick={() => this.props.selectclose()}>
            <CloseIcon />
          </IconButton>
          <Card className={classes.cardBox} variant="outlined" square>
            <Typography
              style={{
                color: this.props.theme.palette.primary.main,
                fontWeight: 'bold',
                fontSize: '2em',
              }}
            >
              Choose your nationality.
            </Typography>
            <Grid container justifyContent="space-between" style={{ marginTop: theme.spacing(3) }}>
              <Grid container onClick={() => this.selectLanguage('korean')} item xs={5} className={classes.box}>
                <img src={`${EVENT_IMG}/for_korean.png`} alt="for korean" style={{ width: '100%', padding: 5 }} />
                <p>For Korean</p>
              </Grid>
              <Grid container onClick={() => this.selectLanguage('english')} item xs={5} className={classes.box}>
                <img src={`${EVENT_IMG}/for_international.png`} alt="for international" style={{ width: '100%', padding: 5 }} />
                <p>For International</p>
              </Grid>
            </Grid>
          </Card>
        </Dialog>

        {/* 아이디찾기 다이얼로그 */}
        <Dialog
          open={this.props.idopen}
          // close={this.props.idclose}
        >
          {/* <div className={classes.paper}> */}
          <IconButton style={{ position: 'absolute', top: '0.5em', right: '0.5em' }} onClick={() => this.props.idclose()}>
            <CloseIcon />
          </IconButton>
          <Card className={classes.cardBox} variant="outlined" square>
            <Typography
              style={{
                color: this.props.theme.palette.primary.main,
                fontWeight: 'bold',
                fontSize: '2.5em',
              }}
            >
              Forgotten your ID(E-mail)?
            </Typography>
            <Typography variant="subtitle1" className={classes.loginInfo} style={{ textAlign: 'left', paddingBottom: theme.spacing(5) }}>
              {this.state.language &&
                this.state.language === 'korean' &&
                'If you do not remember your ID(E-mail), please enter your Name(국문) and CME Credit(의사면허번호).'}
              {this.state.language &&
                this.state.language === 'english' &&
                'If you do not remember your ID(E-mail), please enter your full name.'}
            </Typography>
            <div style={{ borderTop: '1px solid #dddddd', paddingTop: theme.spacing(5) }}>
              {this.state.language && this.state.language === 'korean' && this.renderKr()}
              {this.state.language && this.state.language === 'english' && this.renderInternational()}

              <Button fullWidth color="primary" variant="contained" disableElevation className={classes.submit} onClick={this.submit}>
                Find ID
              </Button>
            </div>
          </Card>
          {/* </div> */}
        </Dialog>
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(FindID);
